import { defaultFilter, defaultForm } from './invoice-parameter-factory';

export type InvoiceParameterRequest = {
  carrierId: number | null;
  financialGroupId: number | null;
  contractId: number | null;
  subContractId: number | null;
  active: boolean | null;
};

export type InvoiceParameterResponse = InvoiceParameterSetting & InvoiceParameterConfig;

export type InvoiceParameterConfig = {
  parentRuleConfigId?: number | null;
  tempId: number;
  ruleId: number | null;
  value: string[] | string | number | boolean | null;
  valueType: string | null;
  possibleValues: any[] | [];
  description: string | null;
  observation: string | null;
  active: boolean | null;
  new: boolean;
  unlink: boolean;
}

export type InvoiceParameterSetting = {
  ruleConfigId: number | null;
  carrierId: number | string | null;
  financialGroupId: number | string | null;
  contractId: number | string | null;
  subContractId: number | string | null;
  name: string | null;
  isApplicable: string | null;
  entityLevel: string | null;
  entityLevelName: string | null;
};

export type Snackbar = {
  show: boolean,
  type: 'success' | 'error' | null,
  message: string,
};

export interface InvoiceParameterForm extends InvoiceParameterSetting {
  configs?: InvoiceParameterConfig[];
};

export class InvoiceParameterModel {
  filter: InvoiceParameterRequest;
  loadingPage: boolean;
  loadingEntities: boolean;
  loadingForm: boolean;
  carriers: any[];
  financialGroups: any[];
  contracts: any[];
  subContracts: any[];
  form: InvoiceParameterForm;
  currentForm: InvoiceParameterForm;
  entities: any[];
  entityKeys: any;
  invoiceParameterStep: number;
  ruleTypes: any[];
  valueTypes: any[];
  configs: InvoiceParameterResponse[];
  creating: boolean;
  updating: boolean;
  copying: boolean;
  showRuleStatusInactiveModal: boolean;
  showRuleStatusActiveModal: boolean;
  showRuleUpdatedSuccessfullyModal: boolean;
  showConfirmAlterationRuleModal: boolean;
  showConflictingRuleFoundModal: boolean;
  showCreateRuleInactiveModal: boolean;
  showRuleStatusInactiveUpdatedModal: boolean;
  showRuleStatusActiveUpdatedModal: boolean;
  showCancelConfirmModal: boolean;
  showRelatedRulesModal: boolean;
  showRuleCreatedModal: boolean;
  showConfirmInfoModal: boolean;
  showRuleUnlinkModal: boolean;
  showRuleLinkModal: boolean;
  showRuleUnlinkSuccessModal: boolean;
  showRuleLinkSuccessModal: boolean;
  showSnackbarCustomize: Snackbar;
  conflictingRuleList: InvoiceParameterResponse[];
  configInValidation: {tempId: number, config: Partial<InvoiceParameterConfig>} | null;
  formsToValidate: any;
  confirmPromiseResolve: any;
  constructor() {
    this.filter = defaultFilter();
    this.loadingPage = false;
    this.loadingEntities = false;
    this.loadingForm = false;
    this.carriers = [];
    this.financialGroups = [];
    this.contracts = [];
    this.subContracts = [];
    this.form = defaultForm();
    this.currentForm = defaultForm();
    this.entities = [];
    this.entityKeys = {
      itemText: '',
      itemValue: '',
    };
    this.invoiceParameterStep = 1;
    this.ruleTypes = [];
    this.valueTypes = [];
    this.configs = [];
    this.creating = false;
    this.updating = false;
    this.copying = false;
    this.showRuleStatusInactiveModal = false;
    this.showRuleStatusActiveModal = false;
    this.showRuleUpdatedSuccessfullyModal = false;
    this.showConfirmAlterationRuleModal = false;
    this.showConflictingRuleFoundModal = false;
    this.showCreateRuleInactiveModal = false;
    this.showRuleStatusInactiveUpdatedModal = false;
    this.showRuleStatusActiveUpdatedModal = false;
    this.showCancelConfirmModal = false;
    this.showRelatedRulesModal = false;
    this.showRuleCreatedModal = false;
    this.showConfirmInfoModal = false;
    this.showRuleUnlinkModal = false;
    this.showRuleLinkModal = false;
    this.showRuleUnlinkSuccessModal = false;
    this.showRuleLinkSuccessModal = false;
    this.showSnackbarCustomize = {
      type: null,
      message: '',
      show: false,
    };
    this.conflictingRuleList = [];
    this.configInValidation = null;
    this.formsToValidate = null;
    this.confirmPromiseResolve = null as null | ((result: boolean) => void);
  }
}